// TablePagination.js
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const TablePagination = ({ totalPages, currentPage, onPageChange }) => {
  const pages = [...Array(totalPages).keys()].map(i => i + 1);

  return (
    <Pagination>
      {pages.map(page => (
        <PaginationItem  key={page} active={page === currentPage}>
          <PaginationLink
            onClick={() => onPageChange(page)}
            href="#"
            style={{backgroundColor : '#DB2777' , borderColor : '#DB2777' }}
          >
            {page}
          </PaginationLink>
        </PaginationItem>
      ))}
    </Pagination>
  );
};

export default TablePagination;
